export default {
  banner: {
    download: 'Tải tài liệu',
    request: 'Xem báo giá',
  },

  modal: {
    title: 'Tài liệu đang được chuẩn bị.',
    desc: 'Chuyển đổi chuyển động không gian thành dữ liệu với công nghệ định vị',
    subDesc:
      'ORBRO giúp hiển thị và tối ưu hóa hoạt động trong các ngành công nghiệp chính như sản xuất, logistics, đô thị thông minh và y tế thông qua dữ liệu vị trí chính xác. Khám phá các trường hợp ứng dụng thực tế và cấu trúc kỹ thuật trong eBook của chúng tôi.',
    descBox: {
      title: 'Nội dung có trong eBook:',
      desc: 'Những thách thức cốt lõi theo từng ngành và giải pháp của ORBRO<br/> • Trường hợp áp dụng thực tế, kiến trúc hệ thống, các tính năng chính<br/> • Cách tích hợp công nghệ RTLS với phân tích AI<br/> • Ví dụ về giao diện người dùng và màn hình dữ liệu phân tích trong môi trường vận hành thực tế',
    },
    download: {
      title: 'Tải tài liệu',
      desc: 'Vui lòng nhập thông tin bên dưới, chúng tôi sẽ gửi tài liệu qua email. Nếu có thắc mắc khác, vui lòng liên hệ ',
      phone: '(+82)1522-9928',
      descTail: ' để được hỗ trợ.',
      time: 'Giờ hành chính (10:00 - 19:00) (KST)',
      ph_email: 'example@orbro.io',

      agree1: '[Bắt buộc]',
      agree2: 'Chính sách bảo mật',
      agree3: 'tôi đồng ý.',

      confirm: 'Tải xuống',
      cancel: 'Hủy',
    },
    subscribe: {
      title: 'Hoàn thành gửi',
      desc: 'Chúng tôi đã gửi tài liệu đến bạn.<br/>Bạn có muốn đăng ký nhận bản tin của ORBRO để cập nhật kỹ thuật và thông tin không?',
      skip: 'Bỏ qua',
      confirm: 'Đăng ký',
    },
    done: {
      title: 'Đã đăng ký',
      desc: 'Cảm ơn bạn đã đăng ký nhận bản tin của ORBRO. Chúng tôi sẽ gửi thông tin và tin tức mới nhất qua email. Hãy cùng ORBRO khám phá thêm nhiều thông tin hữu ích.',
      confirm: 'Xác nhận',
    },
  },

  request: {
    title: 'Liên hệ',
    desc: `Nếu bạn cần triển khai giải pháp, vui lòng nhập thông tin bên dưới và nhấn 'Gửi'.`,
    name: 'Nguyễn Văn A',

    placeholder: {
      name: 'Họ tên',
    },
  },

  contents: {
    title: 'Khám phá các nội dung đa dạng',

    tag: {
      construction: 'Xây dựng',
      logistics: 'Logistics',
      office: 'Văn phòng',
      medical: 'Bệnh viện',
      manufacturing: 'Sản xuất',
      retail: 'Bán lẻ',
    },
  },

  news: {
    title: 'Cập nhật những thông tin mới nhất!',
  },
  ref: [{ text: 'Tổng quan' }, { text: 'Tóm tắt tính năng' }, { text: 'Sản phẩm khuyến nghị' }, { text: 'Blog' }, { text: 'Liên hệ' }],
};
